export const isRunningInNativeApp = () => {
    return (
        !!window.C24App?.isiOSBridgeAvailable() ||
        !!window.C24App?.isAndroidBridgeAvailable()
    );
};

export const isRunningInNativeAndriod = () => {
    return !!window.C24App?.isAndroidBridgeAvailable();
};

export const isRunningInNativeIOS = () => {
    return !!window.C24App?.isiOSBridgeAvailable();
};
